import { Text, View } from '@react-pdf/renderer'

import { commonPdfTableStyles } from '@features/exports/utils/commonTableStyles'

import { useReportsPdfDocument } from '../../../../../../contexts/reportsPdfDocumentContext'
import { columnPdfStyles } from '../../../../../../utils/columnPdfStyles'

export const ReportsPdfTableBalanceSheetHeader = () => {
  const { periods } = useReportsPdfDocument()

  return periods?.map((period) => (
    <View style={columnPdfStyles.columnFluid}>
      <Text key={period.key} style={commonPdfTableStyles.headerLabelText}>
        {period.label}
      </Text>
    </View>
  ))
}
